const contestScroll = function($container) {
  const container = $container || $('body');
  const location = window.location.hash;

  const init = () => {
    $(window).on('load', () => {
      const $target = container.find($(location));

      const afterScroll = () => {
        const newUrl = window.location.href.split('#')[0];
        window.history.pushState(null, null, newUrl);
      };

      const scrollPage = () => {
        $('body, html').stop().animate(
          { scrollTop: $target.offset().top },
          500,
          afterScroll(),
        );
      };

      setTimeout(() => {
        scrollPage();
      }, 500);
    });
  };

  if (location !== '') {
    // init();
  }
};

export default contestScroll;
